import { createFileRoute } from '@tanstack/react-router'
import { COMPLIANCE_STAFF_ROLES } from '@workspace/utils'
import { ComplianceHubPage } from '@/features/compliance-hub'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'

/**
 * Fix wave / A2 (ruling F2/F3): the hub page fetches obligations, which the API
 * gates with the tighter `requireComplianceStaffRead` (no `health_carer` /
 * `supported_employee`) — mirror that list here so a support worker is bounced
 * to /403 up front instead of landing on a half-loaded page. The worker-facing
 * readiness view lives on the Standards page, not here.
 *
 * Role-list reconciliation: `COMPLIANCE_STAFF_ROLES` used to be hand-typed
 * locally in this file (and five siblings — findings, partners,
 * conflicts-of-interest, restrictive-practices index + monthly-report), each
 * copying the API's list from memory with no import to keep them honest. Now
 * a single `@workspace/utils` source, so a future change to either side can't
 * drift unnoticed the way the six copies could.
 */
export const Route = createFileRoute('/_authenticated/_organization/compliance/hub')({
  beforeLoad: async () => {
    await requireRoles([...COMPLIANCE_STAFF_ROLES])
    await requireActiveSubscription()
  },
  component: ComplianceHubPage,
})
